// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-1jJAm";
var _4 = "content-1QlHy";
var _5 = "content_aggregator-3BGfL";
var _6 = "terms-1VH1m";
var _7 = "disclaimer__wrapper-1frRJ";
var _8 = "disclaimer-3vINz";
var _9 = "segments-2RmcA";
var _a = "option-3Mmqf";
var _b = "option_allSegments-HIUUW";
var _c = "form-3q2GR";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "content", _5 as "content_aggregator", _6 as "terms", _7 as "disclaimer__wrapper", _8 as "disclaimer", _9 as "segments", _a as "option", _b as "option_allSegments", _c as "form" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "content": _4, "content_aggregator": _5, "terms": _6, "disclaimer__wrapper": _7, "disclaimer": _8, "segments": _9, "option": _a, "option_allSegments": _b, "form": _c }
